



















import { Component } from 'vue-property-decorator';
import { payHandle } from '@/utils';
import {CONSULTED_LIST } from '../../constant';
import Webview from '../../webview';



@Component
export default class MemberPaySuccess extends Webview {
  created(){
    this.adapter.hideNavBar()
  }
  
  handlePayAgain() {
    const {consultId,channel,tradeNo,sessionId,doctorId} = this.$route.query
     payHandle({tradeNo,consultId,channel,sessionId,doctorId} as any)
  }
}
